import React from "react";

const ErrorPage = ({ errorText, children }) => {
  return (
    <div className="error-page container my-3">
      {errorText ? (
        <div className="alert alert-danger" role="alert">
          {errorText}
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default ErrorPage;
